import { put, call, select, takeEvery } from "redux-saga/effects";
import * as types from "./types";
import * as apis from "../../network/apis/notifications";
import {
  getDropdownNotificationsResponse,
  getNotificationsResponse,
  setUnseenNotificationsCount,
} from "./actions";
import { replaceSeenNotificationInList } from "../../firebase/helpers";
import { showErrorMsg } from "../../utils/Helpers";

function* getNotificationsSaga({ payload }) {
  try {
    const response = yield call(apis.getNotifications, payload);
    yield put(
      getNotificationsResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

// Opening the list leaves the badge: it stays while unread notifications remain (PROLINE-4169).
// Only unread ones are marked seen, so each one marked takes one off.
export function* setNotificationSeen({ payload }) {
  try {
    const response = yield call(apis.setNotificationSeen, payload);
    yield replaceSeenNotificationInList(response.data.data);
    const count = yield select((state) => state.notifications.unseenNotificationsCount);
    const next = Math.max(0, (Number(count) || 0) - 1);
    yield put(setUnseenNotificationsCount(next));
    yield localStorage.setItem("unseenNotificationsCount", next);
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

// `background`: the navbar's ask on every page, with no loader and no error toast.
export function* getDropdownNotificationsSaga({ payload }) {
  const { background, ...params } = payload;
  try {
    const response = yield call(apis.getNotifications, params, { background });
    yield put(getDropdownNotificationsResponse(response.data.data));
  } catch (error) {
    yield error.response && !background && showErrorMsg(error.response?.data?.message);
  }
}

export default function* NotificationsSagas() {
  yield takeEvery(types.GET_NOTIFICATIONS_REQUEST, getNotificationsSaga);
  yield takeEvery(types.SET_NOTIFICATION_SEEN, setNotificationSeen);
  yield takeEvery(
    types.GET_DROPDOWN_NOTIFICATIONS_REQUEST,
    getDropdownNotificationsSaga
  );
}
